/**
 * Blog List Functions
 * Shopify Theme v2.0.1
 * 
 * Handles blog listing, pagination, filtering, and search
 * Required for: Blog pages, Article pages
 */

(function() {
    'use strict';
    
    // Blog settings from theme config
    var blogConfig = {
        postsPerPage: 12,
        showExcerpts: true,
        enablePagination: true,
        excerptLength: 150,
        dateFormat: 'MMM DD, YYYY',
        enableSearch: true,
        enableCategories: true
    };
    
    var blogContainer = document.querySelector('.blog-list-container');
    var blogItems = document.querySelectorAll('.blog-item');
    var paginationLinks = document.querySelectorAll('.pagination a');
    var categoryFilters = document.querySelectorAll('.category-filter');
    var searchInput = document.querySelector('.blog-search-input');
    
    function truncateText(text, length) {
        if (text.length <= length) return text;
        return text.substring(0, length) + '...';
    }
    
    // Format blog dates
    function formatDate(dateString) {
        var date = new Date(dateString);
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear();
    }
    
    // Get URL parameters
    function getUrlParams() {
        var params = {};
        var queryString = window.location.search.substring(1);
        var pairs = queryString.split('&');
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split('=');
            if (pair.length === 2) {
                params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
            }
        }
        return params;
    }
    
    function updateUrlParams(params) {
        var currentParams = getUrlParams();
        for (var key in params) {
            currentParams[key] = params[key];
        }
        var queryString = '';
        for (var key in currentParams) {
            if (currentParams[key]) {
                queryString += (queryString ? '&' : '?') + encodeURIComponent(key) + '=' + encodeURIComponent(currentParams[key]);
            }
        }
        window.history.pushState({}, '', window.location.pathname + queryString);
    }
    
    // Initialize blog functionality
    function initBlog() {
        // Setup category filters
        if (categoryFilters.length) {
            categoryFilters.forEach(function(filter) {
                filter.addEventListener('click', function(e) {
                    e.preventDefault();
                    var category = this.getAttribute('data-category');
                    var currentCategory = getUrlParams().category;
                    if (currentCategory === category) {
                        delete getUrlParams().category;
                        updateUrlParams({ category: '' });
                    } else {
                        updateUrlParams({ category: category });
                    }
                    window.location.reload();
                });
            });
        }
        
        // Setup search functionality
        if (searchInput) {
            var searchTimeout;
            searchInput.addEventListener('input', function() {
                clearTimeout(searchTimeout);
                searchTimeout = setTimeout(function() {
                    var searchTerm = searchInput.value.trim();
                    updateUrlParams({ search: searchTerm });
                    window.location.reload();
                }, 300);
            });
        }
        
        // Setup pagination
        if (paginationLinks.length) {
            paginationLinks.forEach(function(link) {
                link.addEventListener('click', function(e) {
                    e.preventDefault();
                    var page = this.getAttribute('data-page');
                    if (page) {
                        updateUrlParams({ page: page });
                        window.location.reload();
                    }
                });
            });
        }
        
        // Process blog items
        if (blogItems.length) {
            blogItems.forEach(function(item, index) {
                var title = item.querySelector('.blog-title');
                var excerpt = item.querySelector('.blog-excerpt');
                var date = item.querySelector('.blog-date');
                var image = item.querySelector('.blog-image img');
                
                // Truncate excerpts if needed
                if (excerpt && blogConfig.excerptLength) {
                    var originalText = excerpt.textContent.trim();
                    if (originalText.length > blogConfig.excerptLength) {
                        excerpt.textContent = truncateText(originalText, blogConfig.excerptLength);
                    }
                }
                
                // Format dates
                if (date && date.getAttribute('data-date')) {
                    date.textContent = formatDate(date.getAttribute('data-date'));
                }
                
                // Add animation delay to items
                item.style.animationDelay = (index * 0.1) + 's';
            });
        }
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initBlog);
    } else {
        initBlog();
    }
    
})();